export default __webpack_public_path__ + "assets/models/ed2735afcfe3607462052a77ed52d3a4.glb";